import { Component, OnInit } from '@angular/core';
import { ModuleStateComponent } from '../module.state.component';

@Component({
    selector: 'aw-state',
    templateUrl: './state.component.html',
    styleUrls: ['./state.component.less'],
    imports: [ModuleStateComponent]
})
export class StateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
